import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Library, Lock } from "lucide-react";
import { api } from "../../api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("dl_admin_token", data.token);
      navigate("/admin");
    } catch (err) {
      setError(err.response?.data?.detail || "Błąd logowania");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="flex min-h-screen items-center justify-center bg-slate-950 px-4" data-testid="admin-login-page">
      <div className="w-full max-w-sm rounded-3xl glass-panel p-8">
        <div className="flex flex-col items-center">
          <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-cyan-500 to-blue-600 shadow-lg shadow-cyan-500/30">
            <Library className="h-7 w-7 text-white" />
          </div>
          <h1 className="mt-5 font-display text-xl font-extrabold">Panel <span className="gradient-text">DigiLib</span></h1>
          <p className="mt-1 text-xs text-slate-500">Zaloguj się do panelu administracyjnego</p>
        </div>
        <form onSubmit={submit} className="mt-8 space-y-4" data-testid="admin-login-form">
          <input
            data-testid="admin-email-input"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email administratora"
            className="w-full rounded-xl border border-slate-700 bg-slate-900 px-4 py-3 text-sm text-slate-200 placeholder-slate-500 outline-none transition-colors focus:border-cyan-500"
            required
          />
          <input
            data-testid="admin-password-input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Hasło"
            className="w-full rounded-xl border border-slate-700 bg-slate-900 px-4 py-3 text-sm text-slate-200 placeholder-slate-500 outline-none transition-colors focus:border-cyan-500"
            required
          />
          {error && <p className="rounded-lg bg-rose-500/10 border border-rose-500/30 px-3 py-2 text-xs text-rose-300" data-testid="admin-login-error">{error}</p>}
          <button
            data-testid="admin-login-submit"
            disabled={loading}
            className="flex w-full items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-cyan-500 to-teal-500 py-3 font-display text-sm font-bold text-slate-950 transition-transform hover:scale-[1.02] active:scale-95 disabled:opacity-50"
          >
            <Lock className="h-4 w-4" /> {loading ? "Logowanie..." : "Zaloguj się"}
          </button>
        </form>
      </div>
    </main>
  );
}
